module.exports = __webpack_public_path__ + "img/product-atomizer-kangertech-Top_Tank.289b9a83.jpg";